// extracted by mini-css-extract-plugin
module.exports = {"refLink":"e_d2","refLinkDesktop":"e_e2","titleFont":"e_f2"};